module.exports = __webpack_public_path__ + "img/member_shopping_online_icon_435001.de42d4c6.png";